import React, { Component } from 'react';
import './bookings.css';
import 'components/tenant_app/components/tenant_profile/TenantProfile.css';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { localize } from 'react-localize-redux';

import * as bookings from 'actions/bookingsActions';
import { getTenantTodoList } from 'actions/todoActions';
import StripePayment from 'components/shared/StripePayment';
import { CSSTransitionGroup } from 'react-transition-group';
import isEmpty from 'lodash/isEmpty';

import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import { toFriendlyDateString } from 'helpers/Formatter';

const style = {
  button: {
    color: 'white',
    height: '40px',
  },
};

const changeClassName = (availableTime, makeBooking, bookingTime, bookDate) => {
  if (!availableTime) {
    return (
      <button
        type="button"
        className="select_button_availability unavailable"
        style={{ width: '86px', margin: '5px' }}
        tabIndex="-1"
        aria-label="not available"
      >
        &nbsp;
      </button>
    );
  }

  return (
    <button
      type="button"
      className="select_button_availability"
      onClick={() => makeBooking(bookingTime, bookDate)}
      style={{
        backgroundColor: AccentColor(),
        borderColor: AccentColor(),
        width: '86px',
        margin: '5px',
      }}
      aria-label={availableTime}
    >
      {availableTime}
    </button>
  );
};

const displayTimeAvailability = (timeAvailabilities, makeBookingFunction, languageCode) => {
  const timeAvailability = timeAvailabilities.day_0;
  const threeBlocksPerLine = [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32];
  const addSpaceEverySecondRow = [6, 12, 18, 24, 30, 36, 42, 48, 54];
  if (!timeAvailability) return;

  return (
    <div>
      <span className="row">
        <h3 style={{ marginTop: '5px', textAlign: 'center' }}>
          {toFriendlyDateString(new Date(timeAvailability.date), { language: languageCode })}
        </h3>
      </span>
      <div className="row">
        <ul className="availability_array">
          {timeAvailability.available_times.map((availableTime, index) => {
            if (!availableTime) {
              return null;
            }
            let display = 'inline';
            let showRow = 'none';
            if (threeBlocksPerLine.includes(index)) {
              display = 'flex';
            }
            if (addSpaceEverySecondRow.includes(index)) {
              showRow = 'block';
            }
            return (
              <React.Fragment>
                <div className="row" style={{ marginTop: '24px', display: showRow }} />
                <li key={index} style={{ display: display }}>
                  {changeClassName(
                    availableTime,
                    makeBookingFunction,
                    availableTime,
                    timeAvailability.date
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

const selector = formValueSelector('book_showing');
export default connect(
  store => {
    const requestedBookingTime = selector(store, 'requested_booking_length');
    const unitType = selector(store, 'unit_type');
    return {
      requestedBookingTime,
      unitType,
      amenityPricing: store.bookings.amenityPricing,
      languageCode: store.locale.currentLanguage,
    };
  },
  { ...bookings, getTenantTodoList }
)(
  localize()(
    class BookingResults extends Component {
      state = { paymentDialogOpen: false, isBooking: false, showNextAvailable: false };
      // TODO: rewrite this component to use an onClick callback instead of
      // keeping the routing logic here.
      toggleBookingTimes = () => {
        this.setState(prevState => ({ isBooking: !prevState.isBooking }));
      };

      performBooking = (bookTime, bookDate) => {
        this.setState({ isBooking: true }, () => {
          this.makeBooking(bookTime, bookDate);
        });
      };

      makeBooking = async (bookTime, bookDate) => {
        this.props.setToIsLoading();
        if (this.props.createCallCenterBooking) {
          return this.props
            .createCallCenterBooking(bookTime, bookDate, this.props.unitType)
            .catch(e => {
              this.toggleBookingTimes();
              this.props.setToIsLoading(false);
            });
        }

        if (this.props.createFromPropertyBookingPage) {
          return this.props.createFromPropertyBookingPage(bookTime, bookDate);
        }

        if (!this.props.amenityBookingDetails) {
          await this.props.updateBooking(
            this.props.timeAvailability.property_id,
            bookTime,
            bookDate,
            this.props.bookingId,
            this.props.unitType
          );
        }

        if (this.props.amenityBookingDetails && !this.props.amenityBookingDetails.showing_time) {
          await this.props.bookAmenity(
            this.props.amenityBookingDetails.id,
            bookTime,
            bookDate,
            this.props.requestedBookingTime,
            this.props.bookingNotes
          );
          this.props.getTenantTodoList();
          this.props.toggleBookingDialog(this.props.amenityBookingDetails);
        }

        if (this.props.amenityBookingDetails && this.props.amenityBookingDetails.showing_time) {
          await this.props.editAmenityBooking(
            this.props.amenityBookingDetails.booking_id,
            bookTime,
            bookDate,
            this.props.requestedBookingTime
          );
        }

        if (this.props.onComplete) {
          this.props.onComplete();
        }

        this.toggleBookingTimes();
        this.props.setToIsLoading(false);
      };

      UNSAFE_componentWillMount() {
        if (this.props.amenityBookingDetails && this.props.requestedBookingTime) {
          this.props.getAmenityPricing(
            this.props.amenityBookingDetails.id,
            this.props.requestedBookingTime
          );
        }
      }

      componentDidMount() {
        document
          .getElementById('upcoming_availabilities')
          .scrollIntoView({ block: 'start', behaviour: 'smooth' });
      }

      componentWillUnmount() {
        if (this.props.dialogIsClosed && this.props.dialogIsClosed()) {
          this.props.resetBookingsState();
        }
      }

      togglePaymentDialog = () => {
        this.setState({ paymentDialogOpen: !this.state.paymentDialogOpen });
      };

      handleToken = token => {
        const { bookTime, bookDate, id } = this.state;

        let createOrUpdate = this.props.bookAmenity;
        if (this.state.bookType === 'edit_amenity') {
          createOrUpdate = this.props.editAmenityBooking;
        }

        createOrUpdate(id, bookTime, bookDate, this.props.requestedBookingTime, token).then(() => {
          this.props.getTenantTodoList({ show_only: 'AmenityBooking' });
          this.props.toggleBookingDialog(this.props.amenityBookingDetails);
          this.togglePaymentDialog();
        });
      };

      render() {
        if (this.state.isBooking) return null;
        return (
          <div>
            <div>
              <span id={'upcoming_availabilities'}>
                {this.props.isLucky && (
                  <h5 style={{ textAlign: 'center' }}>
                    {this.props.translate('bookings.isLucky')}{' '}
                    {toFriendlyDateString(new Date(this.props.timeAvailability.day_0.date), {
                      language: this.props.languageCode,
                    })}
                  </h5>
                )}
                {!this.props.isLucky &&
                  isEmpty(this.props.timeAvailability) && (
                    <h5 style={{ textAlign: 'center' }}>
                      {this.props.translate('bookings.noAvailability')}
                    </h5>
                  )}
                {!this.props.isLucky &&
                  !isEmpty(this.props.timeAvailability) && (
                    <h5 style={{ textAlign: 'center' }}>
                      {this.props.translate('bookings.noAvailabilityButAvailable')}
                    </h5>
                  )}

                {!this.props.isLucky &&
                  !this.state.showNextAvailable &&
                  !isEmpty(this.props.timeAvailability) && (
                    <div className="row" style={{ textAlign: 'center', marginTop: '2rem' }}>
                      <FlatButton
                        label={this.props.translate('bookings.showNextAvaiable')}
                        onClick={() => this.setState({ showNextAvailable: true })}
                        primary={true}
                        backgroundColor={AccentColor()}
                        hoverColor="grey"
                        style={style.button}
                      />
                    </div>
                  )}
              </span>

              <StripePayment
                open={this.state.paymentDialogOpen}
                toggleOpen={this.togglePaymentDialog}
                pricing={this.props.amenityPricing}
                onToken={this.handleToken}
                fullScreen={this.props.fullScreen}
                additionalVerbiage={this.props.translate('booking.cardNotCharged')}
              />
            </div>
            {this._renderTimesAvailable()}
          </div>
        );
      }

      _renderTimesAvailable = () => {
        if (!this.props.isLucky && !this.state.showNextAvailable) return null;

        return (
          <div>
            <CSSTransitionGroup
              transitionName="fade_out_buttons"
              transitionEnterTimeout={200}
              transitionLeaveTimeout={200}
            >
              {displayTimeAvailability(
                this.props.timeAvailability,
                this.performBooking,
                this.props.languageCode
              )}
            </CSSTransitionGroup>
          </div>
        );
      };
    }
  )
);
